import { RouteObject } from 'react-router-dom';
import { BuyApartmentFlowPaths } from 'routes';
import Requests from 'screens/requests';
import { Apartment, ApartmentNavigation } from 'screens/apartment';
import AparmentDeals from 'screens/apartment-deals';
import ChoosePriceRange from 'screens/choose-price-range';
import BuyApartmentMain from 'screens/buy-apartment-main';
import ApartmentFavoritesMain from 'screens/apartment-favorites-main';
import BuyScreensWrapper from 'components/buy-screens-wrapper';
import BuyApartmentFilters from 'screens/buy-apartment-filters';
import ChooseApartmentPlan from 'screens/choose-apartment-plan';
import ChooseNumberOfRooms from 'screens/choose-number-of-rooms';
import ChooseApartmentComplex from 'screens/choose-apartment-complex';
import ChooseApartmentSquareFootage from 'screens/choose-apartment-square-footage';
import ImageObject from 'screens/imageObject';
import BuyApartmentSort from '../screens/buy-apartment-sort';
import ScreenBuyMode from '../screens/choose-buy-mode';
import ScreenBuySecondary from '../screens/screen-buy-secondary';
import BuySecondaryStreetMap from '../screens/buy-secondary-street-map';
import {
  SecondaryApartmentBuy,
  SecondaryApartmentNavigation,
} from '../screens/secondary-apartment-buy';
import ApartmentListBuySecondary from '../screens/apartment-list-buy-secondary';
import BuySecondaryFilters from '../screens/buy-secondary-filters';
import BuyApartmentSortSecondary from '../screens/buy-apartment-sort-secondary';
import ChoosePriceRangeSecondary from '../screens/choose-price-range-secondary';
import ChooseNumberOfRoomsSecondary from '../screens/choose-number-of-rooms-secondary';
import ChooseApartmentSquareSecondary from '../screens/choose-apartment-square-secondary';
import UserListFavoriteListItem from 'screens/favorite-user-list';
import FavoritesFacilityList from '../screens/favorites-facility-list';

const buyApartmentFlowRouter: RouteObject[] = [
  {
    path: `/`,
    element: <BuyScreensWrapper />,
    children: [
      {
        path: `${BuyApartmentFlowPaths.chooseMode}/*`,
        element: <ScreenBuyMode />,
      },
      {
        path: BuyApartmentFlowPaths.chooseMode,
        element: <ScreenBuyMode />,
      },
      {
        path: BuyApartmentFlowPaths.main,
        element: <BuyApartmentMain />,
      },
      {
        path: BuyApartmentFlowPaths.buySecondary,
        element: <ScreenBuySecondary />,
      },
      {
        path: BuyApartmentFlowPaths.buySecondaryStreetMap,
        element: <BuySecondaryStreetMap />,
      },
      {
        path: BuyApartmentFlowPaths.chooseApartmentComplex,
        element: <ChooseApartmentComplex />,
      },
      {
        path: BuyApartmentFlowPaths.chooseNumberOfRooms,
        element: <ChooseNumberOfRooms />,
      },
      {
        path: BuyApartmentFlowPaths.chooseApartmentPlan,
        element: <ChooseApartmentPlan />,
      },
      {
        path: BuyApartmentFlowPaths.chooseSqFootage,
        element: <ChooseApartmentSquareFootage />,
      },
      {
        path: BuyApartmentFlowPaths.choosePriceRange,
        element: <ChoosePriceRange />,
      },
      {
        path: BuyApartmentFlowPaths.aparmentDeals,
        element: <AparmentDeals />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentListBuySecondary,
        element: <ApartmentListBuySecondary />,
      },
      {
        path: BuyApartmentFlowPaths.apartment,
        element: <Apartment mode='buy' />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentNavigation,
        element: <ApartmentNavigation />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentSecondary,
        element: <SecondaryApartmentBuy />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentSecondaryNavigation,
        element: <SecondaryApartmentNavigation />,
      },
      {
        path: BuyApartmentFlowPaths.image,
        element: <ImageObject />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentFilters,
        element: <BuyApartmentFilters />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentFiltersSecondary,
        element: <BuySecondaryFilters />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentSort,
        element: <BuyApartmentSort />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentSortSecondary,
        element: <BuyApartmentSortSecondary />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentFavorites,
        element: <ApartmentFavoritesMain />,
      },
      {
        path: BuyApartmentFlowPaths.favoritesFacilityList,
        element: <FavoritesFacilityList />,
      },
      {
        path: BuyApartmentFlowPaths.apartmentFavoritesUsers,
        element: <UserListFavoriteListItem />,
      },
      {
        path: BuyApartmentFlowPaths.requests,
        element: <Requests />,
      },
      {
        path: BuyApartmentFlowPaths.choosePriceRangeSecondary,
        element: <ChoosePriceRangeSecondary />,
      },
      {
        path: BuyApartmentFlowPaths.chooseNumberOfRoomsSecondary,
        element: <ChooseNumberOfRoomsSecondary />,
      },
      {
        path: BuyApartmentFlowPaths.chooseSqFootageSecondary,
        element: <ChooseApartmentSquareSecondary />,
      },
    ],
  },
];

export default buyApartmentFlowRouter;
